<template>
    <div v-if="filtersQuickSorted.length > 0" class="filters-quick">
        <div class="filters-quick__title">Szybkie filtry</div>
        <div class="filters-quick__wrapper">
            <ul class="filters-quick__list">
                <li
                    v-for="quickFilter in filtersQuickSorted"
                    :key="`quick-${quickFilter.label}`"
                >
                    <button
                        type="button"
                        class="filters-quick__button btn--small"
                        @click.prevent="
                            dispatchFilters({
                                filters: quickFilter.value
                            })
                        "
                    >
                        {{ quickFilter.label }}
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    props: {
        filtersQuick: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        filtersQuickSorted() {
            const filters = this.filtersQuick
            return filters.sort((a, b) => a.order - b.order)
        }
    },
    methods: {
        ...mapActions(['dispatchFilters'])
    }
}
</script>
<style scoped lang="scss">
.filters-quick {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    scrollbar-color: #007f32 #fff;
    &::-webkit-scrollbar {
        background: #007f32;
    }
    &::-webkit-scrollbar-thumb {
        background: #ffffff;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &__title {
        white-space: nowrap;
    }

    &__list {
        display: flex;
        margin: 10px;
        flex-wrap: nowrap;
        scrollbar-color: #007f32 #fff;
        &::-webkit-scrollbar {
            background: #007f32;
        }
        &::-webkit-scrollbar-thumb {
            background: #fff;
        }
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }

    button,
    &__button {
        margin-right: 10px;
        min-height: 26px !important;
        height: 26px !important;
        padding: 4px 16px;
        background-color: #006729;
        color: white;
        font-size: 12px;
        border-color: #006729;
        border-radius: 24px;
        text-transform: none;

        &:hover {
            background-color: white;
            color: $blue-dianne;
        }

        @media #{$media-xs} {
            margin-bottom: 0;
        }

        svg {
            margin-top: rem(-2px);
            margin-left: rem(2px);
        }
    }

    &__clear {
        border: 0;
    }

    &__wrapper {
        display: grid;
        max-width: 100%;
        overflow-x: auto;
        margin-bottom: 0;
        margin-left: 10px;
    }
}
</style>
